const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000').replace(/\/$/, '')

type QueryValue = string | number | boolean | null | undefined
type RequestConfig = { params?: Record<string, QueryValue> }

async function request<T>(path: string, init?: RequestInit, config?: RequestConfig): Promise<{ data: T }> {
  const url = new URL(`${API_BASE_URL}${path}`)
  for (const [key, value] of Object.entries(config?.params ?? {})) {
    if (value !== null && value !== undefined) url.searchParams.set(key, String(value))
  }

  const controller = new AbortController()
  const timeout = window.setTimeout(() => controller.abort(), 15_000)

  try {
    const response = await fetch(url, {
      ...init,
      signal: controller.signal,
      headers: {
        Accept: 'application/json',
        ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
        ...init?.headers,
      },
    })

    if (!response.ok) throw new Error(`Public API request failed with status ${response.status}`)
    return { data: (await response.json()) as T }
  } finally {
    window.clearTimeout(timeout)
  }
}

export const publicApiClient = {
  get<T>(path: string, config?: RequestConfig) {
    return request<T>(path, undefined, config)
  },
  post<T>(path: string, body: unknown) {
    return request<T>(path, { method: 'POST', body: JSON.stringify(body) })
  },
}
